import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MedicinePaginationDTO } from "../../dtos/manufacturer";
import { RegMedicalDTO, EditMedicalDTO , DeleteMedicalDTO  } from "../../dtos/nonmedical";
import nonMedicalService from "./nonMedicalService";

// Define initial state
const initialState = {
  regNonMedicalPayload: null,
  editNonMedicalPayload: null,
  deleteNonMedicalPayload: null,
  medicineDetails: [],
  medicalId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: <any>"",
  isMedicineLoading: false,
  isMedicineLoadingError: false,

  isRegNonMedicalLoading: false,
  isEditNonMedicalLoading: false,
  deleteNonMedicalLoading: false,

  isRegNonMedicalSuccess: false,
  isEditNonMedicalSuccess: false,
  deleteNonMedicalSucess: false,

  isRegNonMedicalLoadingError: false,
  isEditNonMedicalLoadingError: false,
  deleteNonMedicalLoadingError: false,

  regNonMedicalMessage: "",
  editNonMedicalMessage: "",
  deleteNonMedicalMessage:""

};

export const registerMedical = createAsyncThunk(
  "api/pharmacy/nonmedical/add",
  async (medical: RegMedicalDTO, thunkAPI) => {
    try {
      return await nonMedicalService.RegisterMedical(medical);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const editNonMedical = createAsyncThunk(
  "medical/edit",
  async (medical: EditMedicalDTO, thunkAPI) => {
    try {
      return await nonMedicalService.editNonMedical(medical);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const deleteMedical = createAsyncThunk(
  "pharmacy/medical/delete",
  async (dto: DeleteMedicalDTO, thunkAPI) => {
    try {
      return await nonMedicalService.deleteNonMedical(dto);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getNonMedicalData = createAsyncThunk(
  "medical/getMedicalData", 
  async ({ pharmacy_id, dto }: { pharmacy_id: any; dto?: MedicinePaginationDTO }, thunkAPI) => {
    try {
      const response = await nonMedicalService.getNonMedical(pharmacy_id, dto); 
      return response.data; 
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);



export const medicineSlice = createSlice({
  name: "medicalSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeMedicalId: (state, action) => {
      state.medicalId = action.payload.resp;
    },
  },

  extraReducers: (builder) => {
    builder
    .addCase(registerMedical.pending, (state) => {
      state.isRegNonMedicalLoading = true;
    })
    .addCase(
      registerMedical.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isRegNonMedicalLoading = false;
        state.isRegNonMedicalSuccess = true;
        state.regNonMedicalMessage = "";
        state.regNonMedicalPayload = action.payload.resp;
      }
    )
    .addCase(
      registerMedical.rejected,
      (state, action: PayloadAction<any>) => {
        state.isRegNonMedicalLoading = false;
        state.isRegNonMedicalLoadingError = true;
        state.regNonMedicalMessage = action.payload.resp;
      }
    )
    .addCase(editNonMedical.pending, (state) => {
      state.isEditNonMedicalLoading = true;
    })
    .addCase(editNonMedical.fulfilled, (state, action) => {
      state.isEditNonMedicalLoading = false;
      state.isEditNonMedicalSuccess = true;
      state.isEditNonMedicalLoadingError = false;
      state.editNonMedicalMessage = "";
      state.editNonMedicalPayload = action.payload;
    })
    .addCase(
      editNonMedical.rejected,
      (state, action: PayloadAction<any>) => {
        state.isEditNonMedicalLoading = false;
        state.isEditNonMedicalLoadingError = true;
        state.editNonMedicalMessage = action.payload;
      }
    )

    .addCase(deleteMedical.pending, (state) => {
      state.deleteNonMedicalLoading = true;
    })
    .addCase(deleteMedical.fulfilled, (state, action) => {
      state.deleteNonMedicalLoading = false;
      state.deleteNonMedicalSucess = true;
      state.deleteNonMedicalPayload = action.payload.resp;
      state.deleteNonMedicalLoadingError = false;
      state.deleteNonMedicalMessage = "";
    })
    .addCase(
      deleteMedical.rejected,
      (state, action: PayloadAction<any>) => {
        state.deleteNonMedicalLoading = false;
        state.deleteNonMedicalLoadingError = true;
        state.deleteNonMedicalMessage = action.payload.resp;
      }
    )

      .addCase(getNonMedicalData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNonMedicalData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.medicineDetails = action.payload.resp;
        state.message = "";
      })
      .addCase(getNonMedicalData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});


export const { reset, changeMedicalId } = medicineSlice.actions;
export default medicineSlice.reducer;